export const ONGOING_CAMPAIGN_EMPTY_STATE_CONTENT = [
  {
    id: 1,
    title: 'CAMPAIGN.EMPTY_STATE_EXAMPLES.CHATBOT.TITLE',
    inbox: {
      id: 2,
      name: 'CAMPAIGN.EMPTY_STATE_EXAMPLES.WEBSITE',
      channel_type: 'Channel::WebWidget',
      phone_number: '',
    },
    sender: {
      id: 1,
      name: 'Alexa Rivera',
    },
    message: 'CAMPAIGN.EMPTY_STATE_EXAMPLES.CHATBOT.MESSAGE',
    campaign_status: 'active',
    enabled: true,
    campaign_type: 'ongoing',
    trigger_rules: {
      url: 'https://talkvia.com.br/features/chatbot/',
      time_on_page: 10,
    },
    trigger_only_during_business_hours: true,
    created_at: '2024-10-24T13:10:26.636Z',
    updated_at: '2024-10-24T13:10:26.636Z',
  },
  {
    id: 2,
    title: 'CAMPAIGN.EMPTY_STATE_EXAMPLES.PRICING.TITLE',
    inbox: {
      id: 2,
      name: 'CAMPAIGN.EMPTY_STATE_EXAMPLES.WEBSITE',
      channel_type: 'Channel::WebWidget',
      phone_number: '',
    },
    sender: {
      id: 1,
      name: 'Jamie Lee',
    },
    message: 'CAMPAIGN.EMPTY_STATE_EXAMPLES.PRICING.MESSAGE',
    campaign_status: 'active',
    enabled: false,
    campaign_type: 'ongoing',
    trigger_rules: {
      url: 'https://talkvia.com.br/pricings',
      time_on_page: 10,
    },
    trigger_only_during_business_hours: false,
    created_at: '2024-10-24T13:11:08.763Z',
    updated_at: '2024-10-24T13:11:08.763Z',
  },
  {
    id: 3,
    title: 'CAMPAIGN.EMPTY_STATE_EXAMPLES.SETUP.TITLE',
    inbox: {
      id: 2,
      name: 'CAMPAIGN.EMPTY_STATE_EXAMPLES.WEBSITE',
      channel_type: 'Channel::WebWidget',
      phone_number: '',
    },
    sender: {
      id: 1,
      name: 'Talkvia',
    },
    message: 'CAMPAIGN.EMPTY_STATE_EXAMPLES.SETUP.MESSAGE',
    campaign_status: 'active',
    enabled: false,
    campaign_type: 'ongoing',
    trigger_rules: {
      url: 'https://{*.}?talkvia.com.br/apps/account/*/settings/inboxes/new/',
      time_on_page: 10,
    },
    trigger_only_during_business_hours: false,
    created_at: '2024-10-24T13:11:44.285Z',
    updated_at: '2024-10-24T13:11:44.285Z',
  },
  {
    id: 4,
    title: 'CAMPAIGN.EMPTY_STATE_EXAMPLES.GENERAL.TITLE',
    inbox: {
      id: 2,
      name: 'CAMPAIGN.EMPTY_STATE_EXAMPLES.WEBSITE',
      channel_type: 'Channel::WebWidget',
      phone_number: '',
    },
    sender: {
      id: 1,
      name: 'Chris Barlow',
    },
    message: 'CAMPAIGN.EMPTY_STATE_EXAMPLES.GENERAL.MESSAGE',
    campaign_status: 'active',
    enabled: true,
    campaign_type: 'ongoing',
    trigger_rules: {
      url: 'https://siv.com',
      time_on_page: 200,
    },
    trigger_only_during_business_hours: false,
    created_at: '2024-10-29T19:54:33.741Z',
    updated_at: '2024-10-29T19:56:26.296Z',
  },
];

export const ONE_OFF_CAMPAIGN_EMPTY_STATE_CONTENT = [
  {
    id: 1,
    title: 'CAMPAIGN.EMPTY_STATE_EXAMPLES.FEEDBACK.TITLE',
    inbox: {
      id: 6,
      name: 'CAMPAIGN.EMPTY_STATE_EXAMPLES.MOBILE',
      channel_type: 'Channel::Sms',
      phone_number: '+29818373149903',
      provider: 'default',
    },
    message: 'CAMPAIGN.EMPTY_STATE_EXAMPLES.FEEDBACK.MESSAGE',
    campaign_status: 'active',
    enabled: true,
    campaign_type: 'one_off',
    scheduled_at: 1729775588,
    audience: [
      { id: 4, type: 'Label' },
      { id: 5, type: 'Label' },
      { id: 6, type: 'Label' },
    ],
    trigger_rules: {},
    trigger_only_during_business_hours: false,
    created_at: '2024-10-24T13:13:08.496Z',
    updated_at: '2024-10-24T13:15:38.698Z',
  },
  {
    id: 2,
    title: 'CAMPAIGN.EMPTY_STATE_EXAMPLES.CUSTOMER.TITLE',
    inbox: {
      id: 6,
      name: 'CAMPAIGN.EMPTY_STATE_EXAMPLES.MOBILE',
      channel_type: 'Channel::Sms',
      phone_number: '+29818373149903',
      provider: 'default',
    },
    message: 'CAMPAIGN.EMPTY_STATE_EXAMPLES.CUSTOMER.MESSAGE',
    campaign_status: 'completed',
    enabled: true,
    campaign_type: 'one_off',
    scheduled_at: 1729732500,
    audience: [
      { id: 1, type: 'Label' },
      { id: 6, type: 'Label' },
      { id: 5, type: 'Label' },
      { id: 2, type: 'Label' },
      { id: 4, type: 'Label' },
    ],
    trigger_rules: {},
    trigger_only_during_business_hours: false,
    created_at: '2024-10-24T13:14:00.168Z',
    updated_at: '2024-10-24T13:15:38.707Z',
  },
  {
    id: 3,
    title: 'CAMPAIGN.EMPTY_STATE_EXAMPLES.BUSINESS.TITLE',
    inbox: {
      id: 6,
      name: 'CAMPAIGN.EMPTY_STATE_EXAMPLES.MOBILE',
      channel_type: 'Channel::Sms',
      phone_number: '+29818373149903',
      provider: 'default',
    },
    message: 'CAMPAIGN.EMPTY_STATE_EXAMPLES.BUSINESS.MESSAGE',
    campaign_status: 'active',
    enabled: true,
    campaign_type: 'one_off',
    scheduled_at: 1730368440,
    audience: [
      { id: 1, type: 'Label' },
      { id: 3, type: 'Label' },
      { id: 6, type: 'Label' },
      { id: 4, type: 'Label' },
      { id: 2, type: 'Label' },
      { id: 5, type: 'Label' },
    ],
    trigger_rules: {},
    trigger_only_during_business_hours: false,
    created_at: '2024-10-30T07:54:49.915Z',
    updated_at: '2024-10-30T07:54:49.915Z',
  },
  {
    id: 4,
    title: 'CAMPAIGN.EMPTY_STATE_EXAMPLES.MEMBER.TITLE',
    inbox: {
      id: 6,
      name: 'CAMPAIGN.EMPTY_STATE_EXAMPLES.MOBILE',
      channel_type: 'Channel::Sms',
      phone_number: '+29818373149903',
      provider: 'default',
    },
    message: 'CAMPAIGN.EMPTY_STATE_EXAMPLES.MEMBER.MESSAGE',
    campaign_status: 'completed',
    enabled: true,
    campaign_type: 'one_off',
    scheduled_at: 1730304840,
    audience: [
      { id: 1, type: 'Label' },
      { id: 3, type: 'Label' },
      { id: 6, type: 'Label' },
    ],
    trigger_rules: {},
    trigger_only_during_business_hours: false,
    created_at: '2024-10-29T16:14:10.374Z',
    updated_at: '2024-10-30T16:15:03.157Z',
  },
];
